import { Grid } from "@material-ui/core";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import { getIn, useFormikContext } from "formik";
import React, { memo } from "react";
import { pagingCustomerSource } from "app/services/CustomerSourceService";
import { pagingDepartment } from "app/services/DepartmentService";
import { observer } from "mobx-react";
import { getDepartmentsUser, isAdmin } from "app/common/LocalFunction";
import { LEAD_SOURCE_LEVEL } from "app/common/LocalConst";

const SourceRegister = ({ disabled = false, handleGetListCodeSource }) => {
  const { values, setFieldValue } = useFormikContext();
  const isAdminPermission = isAdmin();
  const departmentsUser = getDepartmentsUser();
  return (
    <Grid
      container
      spacing={1}
      style={{ backgroundColor: "aliceblue", marginBottom: "8px" }}
    >
      <Grid item xs={12} sm={6} md={3}>
        <GlobitsPagingAutocomplete
          api={
            isAdminPermission
              ? pagingDepartment
              : async () => ({
                data: {
                  content: departmentsUser || [],
                  totalElements: departmentsUser?.length || 0,
                  totalPages: 1,
                },
              })
          }
          onChange={(_, value) => {
            setFieldValue("department", value);
            const searchCodeSource = {
              level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
              startDate: values?.startDate,
              patientId: values?.patient?.id,
              departmentId: value?.id,
              voucherIds: Array.isArray(values?.voucherAllocations)
                ? values.voucherAllocations
                  .map(item => item?.voucher?.id)
                  .filter(Boolean)
                : [],

              invoiceItemIds: Array.isArray(values?.invoiceItemAllocations)
                ? values.invoiceItemAllocations
                  .map(item => item?.invoiceItem?.id)
                  .filter(Boolean)
                : [],
            };

            handleGetListCodeSource(searchCodeSource, setFieldValue);
          }}
          name={"department"}
          label="Cơ sở"
          required
          disabled={disabled}
        />
      </Grid>
      {/* <Grid item xs={12} sm={6} md={3}>
        <GlobitsPagingAutocomplete
          api={pagingCustomerSource}
          name={"source"}
          label="Nguồn hiện tại"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <GlobitsPagingAutocomplete
          api={pagingCustomerSource}
          searchObject={{
            parentId: getIn(values, "source")?.id,
          }}
          name={"sourceDetail"}
          label={"Nguồn hiện tại (Chi tiết)"}
        />
      </Grid> */}
    </Grid>
  );
};

export default memo(observer(SourceRegister));
